import { lazy } from 'react';

const Login = lazy(() => import(`../pages/Public/Login`));
const LoginLoad = lazy(() => import(`../pages/Public/LoginLoad`));
const LoginbyToken = lazy(() => import(`../pages/Public/LoginbyToken`));
const Register = lazy(() => import(`../pages/Public/Register`));
const Unsubscribe = lazy(() => import(`../pages/Public/Unsubscribe`));
const ConfirmEmail = lazy(() => import(`../pages/Public/ConfirmEmail`));
const NewUserConfirmation = lazy(() => import(`../pages/Public/NewUserConfirmation`));
const ForgetPassword = lazy(() => import(`../pages/Public/ForgetPassword`));
const TwoFactorVerification = lazy(() => import('./../pages/Public/TwoFactorVerification'));
const PrivacyPolicy = lazy(() => import('../pages/Public/PrivacyPolicy/index'));
const Sac = lazy(() => import('../pages/Public/Sac'));
const PasswordRecovery = lazy(() => import('../pages/Public/PasswordRecovery'));
const VerifyLeads = lazy(() => import('../pages/Public/VerifyLeads'));
const SupportingMaterialPublic = lazy(() => import('../pages/Public/SupportingMaterialPublic'));

type IPublicRoute = {
    path: string;
    page: any;
}

const routes: Array<IPublicRoute> = [
    {
        path: "/login/:userauto/:passwordauto",
        page: Login,
    },{
        path: "/loginLoad/:userauto/:passwordauto/:infodevice",
        page: LoginLoad,
    },{
        path: "/loginLoad/:userauto/:passwordauto",
        page: LoginLoad,
    },
    {
        path: "/login",
        page: Login
    },
    {
        path: "/login/:token",
        page: LoginbyToken
    },
    {
        path: "/two-factor-verification",
        page: TwoFactorVerification
    },
    {
        path: "/register/:sponsor",
        page: Register
    },
    {
        path: "/register",
        page: Register
    },
    {
        path: "/unsubscribe",
        page: Unsubscribe
    },
    {
        path: "/email-confirmation/:id",
        page: ConfirmEmail
    },
    {
        path: "/new-user-confirmation/:id",
        page: NewUserConfirmation
    },
    {
        path: "/forget-password",
        page: ForgetPassword
    },
    {
        path: "/ajuda",
        page: Sac
    },
    {
        path: "/",
        page: Login
    },
    {
        path: "/politica-de-privacidade",
        page: PrivacyPolicy
    },
    {
        path: "/password-recovery/:code",
        page: PasswordRecovery
    },
    {
        path: "/leads/interaction/:leadId/:token/:answer",
        page: VerifyLeads
    },
    {
        path: "/Material-de-Apoio",
        page: SupportingMaterialPublic
    }
]

export default routes;
